
import { Component, Input, OnInit } from '@angular/core';
import { DeliveryCommitmentService } from '@empf-shared/services/transaction/delivery-commitment-service';
import { IDeliveryCommitmentViewModel } from '@empf-shared/services/transaction/delivery-commitment/IDeliveryCommitmentViewModel';
import { GetBestEffortsDeliveryDataApiResponse } from '@origination-shared/services/delivery-commitment/models/GetBestEffortsDeliveryDataApiResponse';
import { ICmsContent } from 'src/shared/models/content.model';
import { ExtendedKeyValuePair } from 'src/shared/models/key-value-pair.model';

@Component({
    selector: 'app-bestefforts-read-only-data',
    templateUrl: './bestefforts-read-only-data.component.html',
    styleUrls: ['./bestefforts-read-only-data.component.sass']
})
export class BesteffortsReadOnlyDataComponent implements OnInit {
    @Input() bestEffortsDeliveryData: GetBestEffortsDeliveryDataApiResponse;
    @Input() dcExistingModel: IDeliveryCommitmentViewModel;
    @Input() cmsModel: ICmsContent;
    @Input() propertyTypeOptions: ExtendedKeyValuePair[];
    @Input() loanPurposesOptions: ExtendedKeyValuePair[];
    isXtraDC: boolean = false;
    constructor(private deliveryCommitmentService: DeliveryCommitmentService) {

    }

    ngOnInit() {
        if (this.dcExistingModel.deliveryCommitment.isMpfXtra)
            this.isXtraDC = true;
    }
    /**
* Returns an array of up to 3 co-borrowers, mapping the flat API fields to objects for display.
*/
    getCoBorrowers(): any[] {
        const data: any = this.bestEffortsDeliveryData && this.bestEffortsDeliveryData.bestEffortsDeliveryData ? this.bestEffortsDeliveryData.bestEffortsDeliveryData[0] : undefined;
        if (!data) { return []; }
        return [1, 2, 3].map(i => ({
            firstName: data[`coBorrower${i}FirstName`],
            middleInitial: data[`coBorrower${i}MiddleInitial`],
            lastName: data[`coBorrower${i}LastName`],
            ssn: data[`coBorrower${i}SSN`],
            suffix: data[`coBorrower${i}Suffix`]
        })).filter(cb => cb.firstName || cb.lastName || cb.ssn);
    }

    getLoanPurposeForDisplay(value) {
        return this.loanPurposesOptions?.find(item => item.value === value)?.name ?? value;
    }

    getPropertyTypeForDisplay(value) {
        return this.propertyTypeOptions?.find(item => item.value === value)?.name ?? value;
    }
}
